import { message } from 'antd';
import { useState, useCallback, useEffect, useRef } from 'react';
import { Navigate, useParams } from "react-router-dom";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import actions from "@/redux/action";
import { requestGetCaptcha, requestLogin, requestSmsCode,getUserInfo } from '@/services/api';
import api_domain_config from '@/config/config';
import LoginRender from './children/LoginRender';
import { GALoginPageDisplay, GALoginFromError } from "@/ga/login";
// import SliderCaptch from '../../components/SliderCaptcha';
import { useSearchParams, useNavigate } from "react-router-dom";
import rules from '@/config/rules';

import './index.less';

const Login = (props) => {
    const [loginLoading, setLoginLoading] = useState(false);
    const [linkToPersonalCenter, setLinkToPersonalCenter] = useState(false); //是否跳转个人中心页面
    const [captchaValue, setCaptchaValue] = useState();
    const [loginType, setLoginType] = useState('accountLogin');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isShowCode, setIsShowCode] = useState(false);
    const [time, setTime] = useState(60);
    const captchaRef = useRef();
    const userPhone = useRef();
    let [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();


    // 提交表单数据
    const handleRequestLogin = async (params) => {
        setLoginLoading(true);
        delete params.agreement;
        let newParams = {
            client_id: api_domain_config.CLIENT_ID,
            client_secret: api_domain_config.CLIENT_SECTET,
            brand_id: 7
        }
        if (loginType === 'accountLogin') {
            params = { ...newParams, grant_type: 'sms', ...params, }
        } else if (loginType === 'pwdLogin') {
            if (params.verify_code !== captchaValue) {
                message.error('验证码错误,请重新输入');
                captchaRef.current.refresh();
                setLoginLoading(false);
                return;
            }
            params = { ...newParams, grant_type: 'password', ...params }
            // console.log(params)
        }
        const { code, data, msg } = await requestLogin(params);
        if (code === 200) {
            setLoginLoading(false);
            message.success('登录成功');
            //保存用户注册登录成功的标识
            localStorage.setItem("isSignin", "yes");
            props.onAuthorizationChange(data.access_token);
            //将当前authorization存在顶级域名cookies底下
            Cookies.set("authorization", data.access_token, { expires: 30, domain: api_domain_config.DOMAIN });
            //登录成功应该判断上个页面链接是什么，如果是购买页应该跳转对应购买页
            handleLoginRedirect()
        } else {
            setLoginLoading(false);
            //刷新图形验证码
            captchaRef.current.refresh();
            GALoginFromError(msg);
        }
    }

    /**
  *控制用户登录完毕登录后的跳转链接
  */
    const handleLoginRedirect = async () => {
        //登录成功之后应该获取当前用户信息，再返回到当前的购买页，否则拿不到用户的信息
        const {code,data} = await getUserInfo();
        if (code === 200) {
            //保存当前的用户信息
            localStorage.setItem('currentUserInfo', JSON.stringify(data))
        }

        if(localStorage.getItem('currentUserInfo') && sessionStorage.getItem('backLink')){
            const backLink = sessionStorage.getItem('backLink');
            //返回购买页
            window.location.replace(backLink)
        }else {
            //跳转到个人中心页面
            setLinkToPersonalCenter(true)
        }
    };


    // 获取短信验证码
    const sendCode = async (phone) => {
        // setIsModalVisible(true);
        // userPhone.current = phone;
        if(!new RegExp(rules.phone).test(phone)) {
            return;    
        }

        if (isShowCode) { // 倒计时未结束,不能重复点击
            return;
        }
        const params = {
            type: 1,
            scene: 2,
            phone: phone,
            brand_id: 7
        }
        const { code } = await requestSmsCode(params);
        if (code === 200) {
            setIsShowCode(true);
            // 倒计时
            const active = setInterval(() => {
                setTime((preSecond) => {
                    if (preSecond <= 1) {
                        setIsShowCode(false)
                        clearInterval(active)
                        // 重置秒数
                        return 60;
                    }
                    return preSecond - 1;
                })
            }, 1000)
            setIsModalVisible(false)
        }
    }

    //滑动验证码验证成功调获取验证码接口
    // const handerSuccess = async () => {
    //     if (isShowCode) { // 倒计时未结束,不能重复点击
    //         return;
    //     }
    //     setIsShowCode(true);
    //     // 倒计时
    //     const active = setInterval(() => {
    //         setTime((preSecond) => {
    //             if (preSecond <= 1) {
    //                 setIsShowCode(false)
    //                 clearInterval(active)
    //                 // 重置秒数
    //                 return 60;
    //             }
    //             return preSecond - 1;
    //         })
    //     }, 1000)

    //     document.querySelector('.verify-bar .icon').classList.add('icon-success');
    //     const params = {
    //         type: 1,
    //         scene: 2,
    //         phone: userPhone.current,
    //         brand_id: 7
    //     }
    //     const { code } = await requestSmsCode(params);
    //     if (code === 200) {
    //         setIsModalVisible(false)
    //     }
    // }

    // 获取图形验证码
    // const getCaptcha = async () => {
    //     if (loginType === 'pwdLogin') {
    //         const { data } = await requestGetCaptcha();
    //         document.getElementById('captcha').src = data.base64_captcha;
    //     }
    // }

    // useEffect(() => {
    //     // getCaptcha()
    //     //添加事件埋点
    //     GALoginPageDisplay()
    //     document.title = "登录-个人中心";
    //     document.querySelector('meta[name="keywords"]').setAttribute('content', '登录');
    //     document.querySelector('meta[name="description"]').setAttribute('content', '登录');

    //     //判断当前登录状态
    //     // console.log(window.location)
    //     // console.log(document.referrer)
    //     // if(Cookies.get("authorization")){
    //     //     //跳转登录页面
    //     //     navigate('/personal-center/order-list', {replace: true})
    //     // }
    // }, [])


    return (
        <>
            {linkToPersonalCenter && <Navigate to="/personal-center/order-list" replace={true} />}
            <LoginRender
                loginLoading={loginLoading}
                sendCode={(phone) => sendCode(phone)}
                isShowCode={isShowCode}
                time={time}
                handleRequestLogin={handleRequestLogin}
                handleClickCaptcha={useCallback((captcha) => setCaptchaValue(captcha), [])}
                handerType={(type) => setLoginType(type)}
                loginType={loginType}
                ref={captchaRef}
            />
            {/* <SliderCaptch
                isModalVisible={isModalVisible}
                handleCancel={() => setIsModalVisible(false)}
                handerSuccess={handerSuccess}
            /> */}
        </>
    );
}


//这个函数允许我们将store中的数据作为props绑定到组件上,当state变化时,函数被调用
const mapStateToPropos = state => ({
    authorization: state.account.authorization,
});

//将action作为props绑定在当前组件上
const mapDispatchToProps = dispatch => ({
    onAuthorizationChange: authorization => dispatch(actions.onAuthorizationChange(authorization))
})


export default connect(mapStateToPropos, mapDispatchToProps)(Login);